import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'
import Table2 from '../../../../components/table/Table2'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import { deleteProduct, emptyOneProduct, loadProducts, loadProductsByWarehouse } from '../../../../store/Actions/ActionProducts'
import { ColumnProducts } from '../../../../components/general/general-component/columns-component/ColumnProducts'
import { useParams } from 'react-router-dom'
import '../StyleProduct.css'
import FilterProduct from '../FilterProduct'
import Config from '../../configration/Config'
import AddProduct from '../add-product/AddProduct'
import ProductSupplier from '../product-supplier/ProductSupplier'
import Movements from '../movements/Movements'
import FilterMovements from '../movements/FilterMovements'
import Tabs from '../../../../components/general/general-component/tabs/Tabs'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'
import EditProduct from '../edit-product'
import { UsePermissions, hasPermissions } from '../../../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../../../components/general/general-component/check-lazy-loader'
import AssignProduct from './AssignProduct'


const ShowProducts = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const materials = hasPermissions([{ name: "materials" }], permissionss);
    const materials_categories = hasPermissions([{ name: "materials-categories" }], permissionss);
    const materials_suppliers = hasPermissions([{ name: "materials-suppliers" }], permissionss);
    const materials_movements = hasPermissions([{ name: "materials-movements" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { products, loadingProducts } = useSelectorCustom()
    const [type, setType] = useState('category')
    const [openEdit, setOpenEdit] = useState(false)
    const [openAssign, setOpenAssign] = useState(false)
    const [idEdit, setIdEdit] = useState(false)
    const { id, name } = useParams()
    //const { state, setOpen, handleEdit, setopenEdit } = VariableWarehouse()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [productsArr, setProductsArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const [activeTap, setActiveTap] = useState('Materials')
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...productsArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setProductsArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, productsArr]);
    useEffect(() => {
        if (products?.length >= 0) {
            setProductsArr(products)
        }
    }, [products]);
    useEffect(() => {
        if (id) {
            dispatch(loadProductsByWarehouse(id))
        } else {
            dispatch(loadProducts())
        }
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteProduct(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const detailOfProduct = (id) => {
        navigate(`/material/${id}`)
    }
    const { columns } = ColumnProducts(translate, warning, langLocal, detailOfProduct, setOpenEdit, setIdEdit,setOpenAssign)
    const newProduct = () => {
        navigate('/add-product')
    }
    const handleSectionClick = (sectionId) => {
        setActiveTap(sectionId);
    };
    const tabs = [
        {
            name: translate('materials'),
            type: 'Materials',
            icon: 'fa-solid fa-cube'
        },
        {
            name: translate('group-category'),
            type: 'Group / Category',
            icon: 'fa-solid fa-border-all'
        },
        {
            name: translate('new_material'),
            type: 'New Material',
            icon: 'fa-solid fa-plus'
        },
        {
            name: translate('supply_purchase'),
            type: 'Supply / Purchase',
            icon: 'fa-solid fa-shopping-cart'
        },
        {
            name: translate('movements'),
            type: 'Movements',
            icon: 'fa-solid fa-maximize'
        },
        {
            name: translate('transaction'),
            type: 'Transaction',
            icon: 'fa-solid fa-text-width'
        },

    ]
    useEffect(() => {
        if (!openEdit) {
            dispatch(emptyOneProduct())
        }
    }, [openEdit])
    return (
        <CheckLazyLoader>
            <main>
                <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >
                    {/*<div className='product_page' >*/}
                    {/*<SidebarProducts activeTap={activeTap} setActiveTap={setActiveTap} />*/}
                    <Tabs langLocal={langLocal} tabs={tabs} activeSection={activeTap} handleSectionClick={handleSectionClick} />
                    {
                        activeTap === 'Materials' && (
                            <>
                                <CheckPermissions array={materials} loadingMainPermission={loadingMainPermission} >
                                    <div >
                                        <FilterProduct translate={translate} bigTitle />
                                        {
                                            loadingProducts ? (
                                                <InnerLoader />
                                            ) : <Table2 col={columns} roo={productsArr} />
                                        }
                                    </div>
                                </CheckPermissions>

                            </>
                        )
                    }
                    {
                        activeTap === 'Group / Category' && (
                            <div>
                                <CheckPermissions array={materials_categories} loadingMainPermission={loadingMainPermission}   >
                                    <Config />
                                </CheckPermissions>
                            </div>
                        )
                    }
                    {
                        activeTap === 'New Material' && (
                            <div>
                                <CheckPermissions array={materials} loadingMainPermission={loadingMainPermission} >
                                    <AddProduct />
                                </CheckPermissions>

                            </div>
                        )
                    }
                    {
                        activeTap === 'Supply / Purchase' && (
                            <div >
                                <CheckPermissions array={materials_suppliers} loadingMainPermission={loadingMainPermission} >
                                    <ProductSupplier translate={translate} />
                                </CheckPermissions>
                            </div>
                        )
                    }
                    {
                        activeTap === 'Movements' && (
                            <div>
                                {
                                    <CheckPermissions array={materials_movements} loadingMainPermission={loadingMainPermission} >
                                        <>
                                            <FilterMovements translate={translate} bigTitle />
                                            <Movements />
                                        </>
                                    </CheckPermissions>
                                }
                            </div>
                        )
                    }

                    {/*</div>*/}

                </div>
            </main>
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                openEdit && (
                    <EditProduct idEdit={idEdit} open={openEdit} setOpen={setOpenEdit} />
                )
            }
            {
                openAssign && (
                    <AssignProduct id={idEdit} open={openAssign} setOpen={setOpenAssign} />
                )
            }
        </CheckLazyLoader>
    )
}

export default ShowProducts
